
var Model = require("../types/Model.js");
var xtend = require("xtend");
var par = require("par");

module.exports = Model({
	name: "managedformsubmissions",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,
	refresh: refresh,
	reset: reset,

	_people: {},
});

function init() {
	this._who = null;
	this._who_tracker = this.dispatcher.createTracker();
	this._people = {};

	this.push([]);
}

function uninit() {
	this._who = null;
	this._who_tracker.off();
	this._who_tracker = null;
	this._people = null;
}

function triggers() {
	return {
		load: load,
		view: view,
		reset: reset,
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_update,
	};
}

function handle_people_update(people) {
	this._people = people;
}

function view(data) {
	var who = data.who;

	if (who === this._who) return;

	this.reset();

	this._who = who;

	var group = data.group;
	this._group = group;

	if(group){
		this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/forms/submission/created", add_submissions.bind(this));
		this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/forms/submission/removed", remove_submission.bind(this));
		this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/forms/submission/updated", update_submission.bind(this));
		this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/forms/submission/locked", update_submission.bind(this));
		this._who_tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/forms/submission/unlocked", update_submission.bind(this));
	} else {
		this._who_tracker.on("mqtt:u/" + who + "/forms/submission/created", add_submissions.bind(this));
		this._who_tracker.on("mqtt:u/" + who + "/forms/submission/removed", remove_submission.bind(this));
		this._who_tracker.on("mqtt:u/" + who + "/forms/submission/updated", update_submission.bind(this));
		this._who_tracker.on("mqtt:u/" + who + "/forms/submission/locked", update_submission.bind(this));
		this._who_tracker.on("mqtt:u/" + who + "/forms/submission/unlocked", update_submission.bind(this));
	}

	this.refresh();

	this.emit("usermetrics:trigger:track", "open managed user's form submissions", {
		who,
	});
}

function reset() {
	if (!this._who) return;
	this.emit("usermetrics:trigger:track", "close managed user's form submissions", {
		who: this._who
	});
	this._who_tracker.off();
	if (this.data.length)
		this.push([]);
	this._who = null;
	this._group = null;
}

function load(data) {
	var who = this._who;
	var group = this._group;
	if (!who) return;
	var page = data.page;
	this.emit("usermetrics:trigger:track", "open managed user's form submissions", {
		who,
	});
	return this.api.manage.forms.submission.list(who, page, group).then(add_submissions.bind(this));
}

function refresh() {
	var who = this._who;
	var group = this._group;
	if (!who) return;
	return this.api.manage.forms.submission.list(who, 0, group).then(handle_refreshed.bind(this));
}

function handle_refreshed(submissions) {
	var people = this._people;
	if(submissions.length < 16 || !submissions.length) this.dispatch("end");
	this.push(submissions.map(addTimestamp).map(par(addPeople, people)).map(par(addIfCreator, this.config.id)));
}

function add_submissions(submissions) {

	if(submissions.length < 16 || !submissions.length) this.dispatch("end");
	submissions = [].concat(submissions);
	var old = this.data.filter(function (old_sub) {
		return !submissions.some(function (new_sub) {
			return new_sub._id === old_sub._id;
		});
	});

	var all = old.concat(submissions);
	var people = this._people;
	var sorted = all.sort(function (a, b) {
		var aTime = (new Date(a.created_at)).getTime();
		var bTime = (new Date(b.created_at)).getTime();

		return bTime - aTime;
	});

	var timestamped = sorted.map(addTimestamp);

	var creatored = timestamped.map(par(addIfCreator, this.config.id));
	var newData = creatored.map(par(addPeople, people));
	this.push(newData);
}

function update_submission(data) {
	var id = data._id;

	var submissions = this.data.map(function (item) {
		if (item._id !== id) return item;
		return xtend(item, data);
	});

	this.push(submissions);
	this.refresh();
}

function remove_submission(data) {
	var submission = data._id;
	var submissions = this.data.filter(function (item) {
		return item._id !== submission;
	});

	this.push(submissions);
}

function addIfCreator(ownid, submission) {
	return xtend(submission, {
		isCreator: submission.creator === ownid
	});
}

function addPeople(people, submission) {
	var creator = submission?.creator;
	var editor = submission?.edited;
	const locker = submission?.locker;

	var editedBy = editor[editor.length - 1];
	var creatorData = people?.[creator];
	var editorData = people?.[editedBy] || creatorData;
	const lockerData = people?.[locker] || {};

	return xtend(submission, {
		creatorData: creatorData,
		editorData: editorData,
		lockerData: lockerData,
	});
}

function addTimestamp(banner) {
	var date = new Date(banner.created_at);
	var timestamp = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();

	return xtend(banner, {
		timestamp: timestamp
	});
}
